import { render, staticRenderFns } from "./DashChart.vue?vue&type=template&id=098f8f80&scoped=true"
import script from "./DashChart.vue?vue&type=script&lang=js"
export * from "./DashChart.vue?vue&type=script&lang=js"
import style0 from "./DashChart.vue?vue&type=style&index=0&id=098f8f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098f8f80",
  null
  
)

export default component.exports